import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  notificationListPageSize: 0,
  notificationListScrollTop: 0,
  notificationListBaseTime: '',
  notificationList: [],
  notification: {},
  notificationCache: {},
  weatherAlertListPageSize: 0,
  weatherAlertListScrollTop: 0,
  weatherAlertListBaseTime: '',
  weatherAlertList: [],
  weatherAlert: {},
  weatherAlertCache: {},
  responseCode: 200,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.ON_UNMOUNT_NOTIFICATION_LIST: {
      const { scrollTop } = action.payload;
      return {
        ...state,
        notificationListScrollTop: scrollTop,
      };
    }
    case actionTypes.ON_UNMOUNT_WEATHER_ALERT_LIST: {
      const { scrollTop } = action.payload;
      return {
        ...state,
        weatherAlertListScrollTop: scrollTop,
      };
    }
    case actionTypes.ON_CLEAR_CACHE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GET_NOTIFICATION_LIST.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GET_NOTIFICATION.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GET_WEATHER_ALERT_LIST.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.GET_WEATHER_ALERT.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
